<template>
  <div class="users">
    <v-container fluid>
      <v-card>

        <v-card-title>
          <v-row dense style="max-width:800px">
            <v-btn small color="primary" @click="form_id = 'new'" style='margin:10px'>New</v-btn>
            <v-col cols="12" sm="12" md="4">
              <v-text-field outlined dense v-model="search" append-icon="mdi-magnify" label="Search Users..." single-line hide-details autocomplete="off"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-switch v-model="show_only_active_users" label="Show Only Active Users" style="margin:0 20px;width:250px;"></v-switch>

        <v-data-table dense :mobile-breakpoint="0" :search="search" must-sort :headers="!isMobile ? headers : $_.filter(headers, {show_mobile: true})" :items="filtered_users" :items-per-page="-1" hide-default-footer :footer-props="{'items-per-page-options': [25,50,100,500,-1]}" :height="$vuetify.breakpoint.height - 264 + 'px'" fixed-header>

          <template v-slot:item="row">
              <tr>
                <td :class="{'inactive': row.item.disabled}">
                  <span class="table-link" v-on:click="$router.push({name: 'User', params: {userId: row.item.id}})" v-if="!row.item.disabled">{{row.item.name}}</span>
                  <span v-if="row.item.disabled">{{row.item.name}}</span>
                </td>
                <td :class="{'inactive': row.item.disabled}" v-if="!isMobile">{{row.item.email}}</td>
                <td :class="{'inactive': row.item.disabled}" v-if="!isMobile">{{row.item.role}}</td>

                <td v-if="!row.item.disabled">
                  <v-tooltip right color="#223773">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-icon v-bind="attrs" v-on="on">
                        <v-icon style="cursor:pointer" @click="disableUser(row.item.id)" v-if="row.item.id !== current_user">mdi-trash-can</v-icon>
                      </v-list-item-icon>
                    </template>
                    <span>Deactivate User</span>
                  </v-tooltip>
                </td>

                <td v-if="row.item.disabled">
                  <v-tooltip right color="#223773" style="height:20px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item-icon v-bind="attrs" v-on="on">
                        <v-icon style="cursor:pointer" @click="enableUser(row.item.id)">mdi-restore</v-icon>
                      </v-list-item-icon>
                    </template>
                    <span>Reactivate User</span>
                  </v-tooltip>
                </td>

              </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>


    <UserForm v-if="form_id" :id="form_id" @close="form_id = null" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserForm from '../components/forms/UserForm.vue'
import axios from 'axios'

export default {
  name: 'users',
  components: {UserForm},
  data(){
    return{
      show_only_active_users: true,
      form_id: null,
      search: '',
      filter: 'All Users',
      headers: [
        { text: 'Name', align: 'start', value: 'name'},
        { text: 'Email', value: 'email' },
        { text: 'Role', value: 'role' },
        { text: '', value: '', sortable: false}
      ]
    }
  },
  beforeMount(){
    if(!this.is_admin){
      this.$router.push('/home')
    }
  },
  computed: {
    ...mapGetters({
      db: 'db',
      current_user: 'current_user',
      active_users: 'active_users',
      inactive_users: 'inactive_users',
      all_users: 'all_users',
      isMobile: 'isMobile',
      users_function_url: 'users_function_url',
      is_admin: 'is_admin'
    }),
    filtered_users: function(){
      return this.show_only_active_users ? this.active_users : this.all_users
    }
  },

methods: {
  disableUser(uid) {
    const user = this.db.users?.[uid];
    if (!user) {
      alert("User record not found.");
      return;
    }

    const confirm_disable = confirm(`Are you sure you want to disable access for ${user.first_name || ""} ${user.last_name || ""}?`);
    if (!confirm_disable) return;

    this.$store.state.isLoading = true;

    const url = this.users_function_url + "disableUser?uid=" + uid;
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST"
    };

    axios.post(url, { headers })
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$store.state.notification =
              response.data.success?.message || response.data.error?.message || "Unknown error disabling user.";
        })
        .catch(() => {
          this.$store.state.isLoading = false;
          this.$store.state.notification = "Unknown error disabling user.";
        });
  },

  enableUser(uid) {
    const user = this.db.users?.[uid];
    if (!user) {
      alert("User record not found.");
      return;
    }

    const confirm_enable = confirm(`Are you sure you want to reactivate access for ${user.first_name || ""} ${user.last_name || ""}?`);
    if (!confirm_enable) return;

    this.$store.state.isLoading = true;

    const url = this.users_function_url + "enableUser?uid=" + uid;
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST"
    };

    axios.post(url, {headers})
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$store.state.notification =
              response.data.success?.message || response.data.error?.message || "Unknown error reactivating user.";
        })
        .catch(() => {
          this.$store.state.isLoading = false;
          this.$store.state.notification = "Unknown error reactivating user.";
        });
     }
  },
}


</script>

<style lang="scss" scoped>

  .v-list-item__icon{height: 0 !important}

  .inactive{
    color: #C0C0C0;
  }
</style>


